// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"640da213","309":"c237dfc6","705":"640da213"}[chunkId] + ".chunk.css";
};